import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// Moved to `pdf-importer`; old bookmarks and links still land here.
export const Route = createFileRoute('/_authenticated/supplier-portal/quote-requests/$quoteRequestId/import-pdf')({
    // Only redirects: the importer checks its own access.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/supplier-portal/quote-requests/$quoteRequestId/pdf-importer',
            params: { quoteRequestId: params.quoteRequestId },
            search: true,
            replace: true,
        });
    },
});
